import { NgModule } from '@angular/core';
import { OrderItemDescriptionPipe } from '../../widgets/order-item-description/order-item-description.pipe';

@NgModule({
  declarations: [OrderItemDescriptionPipe],
  exports: [OrderItemDescriptionPipe],
  providers: [OrderItemDescriptionPipe],
})
export class OrderItemDescriptionModule {}
